import axios from 'axios';
import { gatewayUrl } from '../constants/globalConfig';
import AuthService from '../helpers/authService';

const api = axios.create({
    baseURL: gatewayUrl,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Max-Age': 86400,
    },
});

api.interceptors.request.use(async (config) => {
    const authService = new AuthService();
    const jwtAuth = await authService.getToken();
    if (jwtAuth) {
        config.headers.Authorization = `Bearer ${jwtAuth}`;
    }
    return config;
});

export default api;
